<template>
  <div class="hm-collections-item">
    <CompTodoList v-model="value" @onAddItem="handleClickAdd">
      <template slot="body" slot-scope="scope">
        <div class="setting">
          <div class="setting-input">
            <el-input
              v-model="scope.data.title"
              placeholder="标题"
              size="small"
              class="topic-input"
            />
          </div>
          <div class="setting-input">
            <el-input
              v-model="scope.data.subtitle"
              placeholder="副标题"
              size="small"
              class="topic-input"
            />
          </div>
          <div class="setting-pic">
            <SpImagePicker v-model="scope.data.imgUrl" size="small" />
          </div>
          <div class="setting-input">
            <CompPickerLink v-model="scope.data.urlData"></CompPickerLink>
          </div>
        </div>
      </template>
    </CompTodoList>
  </div>
</template>
<script>
import CompTodoList from "../../comps/comp-todoList.vue";
import CompPickerLink from '../../comps/comp-pickerLink'
export default {
  name: 'AttrItem',
  components: {
    CompTodoList,
    CompPickerLink
  },
  props: ['value'],
  methods: {
    async handleClickAdd() {
      this.value.push({
        imgUrl: '',
        page: '',
        url: '',
        title: '商品标题',
        subtitle: '商品副标题',
        id: ''
      })
    },
  }
}
</script>
<style scoped lang="scss">
.hm-collections-item{
  .setting-input{
    margin-bottom: 10px;
  }
  .setting-pic{
    margin-bottom: 10px;
  }
}
</style>
